import React from "react";
import {FormattedMessage} from "react-intl";
import appearancesInPast from "@default/lib/appearances-in-past";

const ArchivedEventInfo = ({content}) => {

  if (appearancesInPast(content.fieldAppearances)) {
    return (
      <div className="col-12 passed-event-info">
        <FormattedMessage id={"event.passed"}/>
      </div>
    );
  }
}

export default ArchivedEventInfo;